<template>
    <div>
        <template v-if="! loading">
            <b-row>
                <b-col class="px-0 pb-2">
                    <b-card>
                        <b-card-title title-tag="h5" title="Welcome"></b-card-title>
                        <b-card-body class="px-0">
                            <p class="card-text">Welcome to the booking system.</p>

                            <template v-if="bookingOpen">
                                <p class="card-text">You can now book your appointment.</p>
                            </template>
                            <template v-else>
                                <p class="card-text">Booking is currently closed but registrations are open.</p>
                                <p class="card-text">Click on the link below to get yourself registered and ready for when booking is open.</p>
                            </template>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="px-0 pb-2">
                    <b-card class="px-0">
                        <b-card-body class="text-center">
                            <div class="mb-2">
                                <a :href="$routes.route('bookings.register')">
                                    <i class="text-primary fal fa-fw fa-file-signature" style="font-size: 5em;"></i>
                                </a>
                            </div>
                            <div>
                                <b-button variant="primary" :href="$routes.route('bookings.register')">Register Now</b-button>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-col>
                <b-col class="px-0 pb-2">
                    <b-card class="px-0">
                        <b-card-body class="text-center">
                            <template v-if="bookingOpen">
                                <div class="mb-2">
                                    <a :href="$routes.route('bookings.login.index')">
                                        <i class="text-primary fal fa-fw fa-sign-in-alt" style="font-size: 5em;"></i>
                                    </a>
                                </div>
                                <div>
                                    <b-button variant="primary" :href="$routes.route('bookings.login.index')">Book Now</b-button>
                                </div>
                            </template>
                            <template v-else>
                                <div class="mb-2">
                                    <a>
                                        <i class="text-muted fal fa-fw fa-sign-in-alt" style="font-size: 5em;"></i>
                                    </a>
                                </div>
                                <div>
                                    <b-button variant="primary" disabled>Booking Closed</b-button>
                                </div>
                            </template>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        bookingOpen: {
            default: false
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        init() {
            this.loading = false;
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    }
}
</script>